import React, { useEffect, useRef, useState } from 'react'
import { Button, Container, Form, Input, Toast } from 'reactstrap'
import useGetAuthed from '../../helpers/hooks/useGetAuthed'
import toastr from 'toastr'
import useGet from '../../helpers/hooks/useGet';
function UserDeleted() {

  const [userId, setUserId] = useState('');

  // const userId = useRef('');

  const [data,error, loading, call] = useGet(`administrators/${userId}`) 
  useEffect(() => {
    if(data){
      console.log(data)
      toastr.success(data.message)
    }
    if(error){
      console.log(error)
      toastr.error(error.message)
    }
  },[data, error])
  return (
    <React.Fragment>
    <Container fluid>
      <div className='page-content'>
        <div style={{marginLeft: '200px'}}>
          <h1>User Delete</h1>

      <Form onSubmit={(e) => {
        e.preventDefault()
        console.log(userId)
        call()
        }}>
        
      <Input value={userId} type="text" placeholder="Phone Number" style={{width: '30%'}} onChange={(e) => {setUserId(e.target.value);}} />
      <Input type="text" className='mt-3' placeholder="Comment" style={{width: '30%'}} />
      {/* <div className='d-flex justify-content-center'> */}
      <Button color="danger" className='mt-3'>Delete</Button>
      {/* </div> */}
      </Form>
        </div>
      </div>
    </Container>
  </React.Fragment>
  )
}

export default UserDeleted